"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEqualHeaderCustomizer = exports.createQueryFilter = exports.includeGlobalFilters = exports.updateHeadersAndFiltersFromSelection = exports.createLocalHeadersFromFilters = exports.createQueryFiltersFromPersistentFilters = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var filterTypeToValueMap = {
  0: false,
  1: true,
  2: 'both'
};
var filterValueToTypeMap = {
  "false": 0,
  "true": 1,
  both: 2
};

var filterTypeToQueryMap = function filterTypeToQueryMap(item, filterType) {
  var filterMap = {
    0: function _(row) {
      return row[item.name] === false;
    },
    1: function _(row) {
      return row[item.name] === true;
    },
    2: function _(row) {
      return row[item.name] === true || row[item.name] === false;
    }
  };
  return filterMap[filterType];
};

var createQueryFiltersFromPersistentFilters = function createQueryFiltersFromPersistentFilters(persistentFilters) {
  return persistentFilters.map(function (filter) {
    var newFilter = (0, _cloneDeep["default"])(filter);

    newFilter.query = function (rowData) {
      return rowData.filter(filterTypeToQueryMap(newFilter, filterValueToTypeMap[newFilter.value]));
    };

    return newFilter;
  });
};

exports.createQueryFiltersFromPersistentFilters = createQueryFiltersFromPersistentFilters;

var createLocalHeadersFromFilters = function createLocalHeadersFromFilters(headers, filters) {
  return headers.map(function (header) {
    var cloneHeaderItem = _objectSpread({}, header);

    var name = header.name;
    var filtersForHeader = filters.filter(function (f) {
      return f.name === name && f.filterType === 'filter-selector';
    });

    if (filtersForHeader && filtersForHeader.length) {
      cloneHeaderItem.filterType = filterValueToTypeMap[filtersForHeader[0].value];
      return cloneHeaderItem;
    }

    if (header.isFilterable) {
      return cloneHeaderItem;
    }
  }).filter(function (o) {
    return o !== undefined;
  });
};

exports.createLocalHeadersFromFilters = createLocalHeadersFromFilters;

var updateHeadersAndFiltersFromSelection = function updateHeadersAndFiltersFromSelection(localHeaders, localFilters, item, filterType) {
  // remove any pre-existing filters of the same name to be replaced with new selection
  var otherFilters = localFilters.filter(function (f) {
    return f.name !== item.name;
  }); // create new headers and filters from filter selection

  var headers = localHeaders.map(function (headerItem) {
    var cloneHeaderItem = _objectSpread({}, headerItem);

    if (item.name === cloneHeaderItem.name) {
      if (cloneHeaderItem.filterType === 2) {
        if (filterType === 1) {
          cloneHeaderItem.filterType = 0;
          otherFilters.push(createQueryFilter(item, cloneHeaderItem.filterType));
        } else {
          cloneHeaderItem.filterType = 1;
          otherFilters.push(createQueryFilter(item, cloneHeaderItem.filterType));
        }
      } else if (cloneHeaderItem.filterType === undefined) {
        if (filterType === 0) {
          otherFilters.push(createQueryFilter(item, filterType));
        }

        if (filterType === 1) {
          otherFilters.push(createQueryFilter(item, filterType));
        } else if (filterType === 2) {
          otherFilters.push(createQueryFilter(item, filterType));
        }

        cloneHeaderItem.filterType = filterType;
      } else if (cloneHeaderItem.filterType !== filterType) {
        cloneHeaderItem.filterType = 2;
        otherFilters.push(createQueryFilter(item, cloneHeaderItem.filterType));
      } else {
        cloneHeaderItem.filterType = undefined;
      }
    }

    return cloneHeaderItem;
  });
  return [headers, otherFilters];
};

exports.updateHeadersAndFiltersFromSelection = updateHeadersAndFiltersFromSelection;

var includeGlobalFilters = function includeGlobalFilters(filters) {
  return filters.filter(function (f) {
    return f.filterType !== 'filter-selector';
  });
};

exports.includeGlobalFilters = includeGlobalFilters;

var createQueryFilter = function createQueryFilter(item, filterType) {
  return {
    name: item.name,
    value: filterTypeToValueMap[filterType],
    filterType: 'filter-selector',
    query: function query(rowData) {
      return rowData.filter(filterTypeToQueryMap(item, filterType));
    }
  };
};

exports.createQueryFilter = createQueryFilter;

var isEqualHeaderCustomizer = function isEqualHeaderCustomizer(objValue, othValue) {
  if (objValue && othValue && objValue.props && othValue.props) {
    return true;
  }
};

exports.isEqualHeaderCustomizer = isEqualHeaderCustomizer;